export const MILLISECONDS_TO_APPLY_FILTER = 1000;
